import { ProductCodes } from 'constants/payments';
import { DISCOUNT_TYPES } from 'constants/subscriptions';

import { Product, IUpcomingProduct, SubscriptionProductCodeTypes } from './product';
import { PaymentMethods } from './enums';

export enum PaymentProviders {
    Inary = 'inary',
    Solidgate = 'solidgate',
}

export enum DiscountTypes {
    base = 'base',
    extra = 'extra',
}

export interface ICancelSubscriptionRequest {
    id: string;
    provider: PaymentProviders;
}

export interface IDiscounts {
    discount: string | null;
    pause: string | null;
    free_month: string | null;
    isDiscountOfferAvailable?: boolean;
}

export interface SubscriptionPause {
    pause_from: string | null;
    pause_to: string | null;
    pause_type: IPauseType;
}

export interface SubscriptionFee {
    fee_enabled: boolean;
    fee_type: 'annual';
    fee_rebill_left: number;
    fee_amount: number;
    fee_total_price: number;
    fee_expired_at: string;
    fee_price: number;
    fee_period: number | null;
    fee_percentage: number | null;
}

export interface ISubscription {
    expired_date: string;
    external_id: string;
    discounts: IDiscounts;
    reminder: boolean;
    id: number;
    price: string;
    product: Product;
    subscription_period: number;
    subscription_trial_period: number | null;
    fee: SubscriptionFee;
    product_code: ProductCodes;
    product_type?: SubscriptionProductCodeTypes;
    pause: SubscriptionPause;
    payment_provider: PaymentProviders;
    purchase_date: string;
    state: string;
    is_trial: boolean;
    is_upgrade: boolean;
    cancelled_at: string;
    internal_cancel_at: string;
    upcoming_product: IUpcomingProduct | null;
    period: number;
    trial_period: number;
    billing_cycles?: number | null;
    payment_method: PaymentMethods;
    is_promo_code_used?: boolean;
}

export interface IDiscountSubscription {
    id: string;
    name: string;
    amount: number;
    currency: string;
    trial: boolean;
    subscription_period: number;
    subscription_trial_period: null | number;
    started_from: string;
    product_id: string;
    price: number;
    trial_price: number;
}

export interface IDiscountSubscriptionUpdate {
    updatedSubscription: IUpdateSubscription;
    onSuccess: () => void;
    onError: () => void;
}

export interface IResetSubscription {
    id: string;
    product: IDiscountSubscription;
    expired_at?: string;
    discount_type: DISCOUNT_TYPES;
    provider: PaymentProviders;
}

export interface IUpdateSubscription {
    id: string;
    product: IDiscountSubscription;
    discount_type: DISCOUNT_TYPES;
    provider: PaymentProviders;
}

export interface IRestoreSubscription {
    external_id: string;
    provider: PaymentProviders;
}

export interface FeedbackFormValues {
    reason: string;
    comment?: string;
}

export type IPauseType = 'pause' | 'free_month';
